import { render, staticRenderFns } from "./DevMasterNewGroup.vue?vue&type=template&id=70210c15&scoped=true"
import script from "./DevMasterNewGroup.vue?vue&type=script&lang=js"
export * from "./DevMasterNewGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70210c15",
  null
  
)

export default component.exports